<template lang="pug">
  .component-ranger-picker
    VueCtkRangeDatePicker(
      v-model="internalValue"
      :format="format"
      :label="label"
      :range="true"
      :noLabel="true"
      :noHeader="false"
      color="#5EB9CF"
      formatted="ll"
    )
</template>

<script>

  import VueCtkRangeDatePicker from 'vue-ctk-date-time-picker';
  import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

  export default {
    name: 'DateRangePicker',
    components: {
      VueCtkRangeDatePicker
    },
    data() {
      return {
        internalValue: null,
      }
    },
    props: {
      value: {
        type: Object,
        default: () => {
          return {
            start: null,
            end: null,
          }
        },
      },
      label: {type: String, default: "Select range"},
      format: {type: String, default: "YYYY-MM-DD"},
    },
    created() {
      // We initially sync the internalValue with the value passed in by the parent
      this.internalValue = this.value
    },
    watch: {
      internalValue: function () {
        // When the internal value changes, we $emit an input event, updating the parent value
        const i = this.internalValue
        if (i === null) {
          this.$emit('input', {
            start: null,
            end: null,
          })
        } else if (i.start && i.end) {
          this.$emit('input', this.internalValue)
        }
      },
      value: function (newVal) {
        this.internalValue = newVal
      }
    },
  }
</script>

<style lang="sass">
  .header-picker
    display: block !important

  .shortcuts-container
    height: 100% !important
</style>



// WEBPACK FOOTER //
// DateRangePicker.vue?f3b24656